// Import Dependencies
import React, { useRef, useState } from 'react';
import useScrollOnDrag from 'react-scroll-ondrag';
import PropTypes from 'prop-types';
import { Swiper, SwiperSlide } from 'swiper/react';

// Import Components
import Button from '../Button';

// Import Utilities
import { getClassNames, toggleClass, isMediaMatched } from '../../../utils';

const mediaQuery = isMediaMatched(1200);

const urlParams = new URLSearchParams(window.location.search);

const hasPrefilteredMonth = ['month', 'year'].filter(key => urlParams.get(key)).length > 0;

const getFormattedPrefilteredDate = () => `${urlParams.get('month')}/20${urlParams.get('year')}`;

const MonthSlider = ({ filterConcerts, months, ...props }) => {
  const [activeIndex, setActiveIndex] = useState(
    hasPrefilteredMonth
      ? months.length - 1 - months.slice().reverse().findIndex((month) => month.id === getFormattedPrefilteredDate())
      : 0,
  );

  const sliderWrapper = useRef(null);

  const { events } = useScrollOnDrag(sliderWrapper);

  const updateText = (button, index) => {
    if (index === 0) {
      button.innerText = 'Soon';
    }
  };

  const removeActiveClass = (/* activeButton */) => {
    const monthButtons = [...document.querySelectorAll('.js-month-button')];
    monthButtons.forEach((button, index) => {
      /* if (button !== activeButton && button.classList.contains('is-active')) {
        const buttonText = button.id;
        button.classList.remove('is-active');
        button.innerText = buttonText;
      } */

      updateText(button, index);
    });
  };

  const handleEdit = (e, index) => {
    const activeButton = e.target;
    setActiveIndex(index);
    removeActiveClass(activeButton);
    toggleClass(activeButton, 'is-active');
    filterConcerts(e);
  };

  if (window.outerWidth < 1200) {
    return (
      <div className="c-vertical-slider">
        <Swiper
          spaceBetween={0}
          slidesPerView="auto"
          direction={mediaQuery ? 'vertical' : 'horizontal'}
        >
          {months.map((month, i) => {
            // if it's actually a year separator and not a month
            if (typeof month === 'number') {
              return (
                <SwiperSlide className="c-vertical-slider__year" key={month}>
                  {month}
                </SwiperSlide>
              );
            }

            return (
              <SwiperSlide
                key={month.id}
                className={getClassNames(props, 'c-vertical-slider__slide', {
                  'c-vertical-slider__slide--next-year': !!month.isNextYear,
                  'is-active': i === activeIndex,
                })}
              >
                <Button
                  fullHeight
                  fixedWidth
                  borderZero
                  monthSlider
                  blue
                  id={month.id}
                  index={i}
                  onClick={(e) => handleEdit(e, i)}
                  isActive={i === activeIndex}
                  disabled={!month.available}
                >
                  {month.name}
                </Button>
              </SwiperSlide>
            );
          })}
        </Swiper>
      </div>
    );
  }

  return (
    <div className="c-vertical-slider__wrapper" ref={sliderWrapper} {...events}>
      <div className="c-vertical-slider">
        {months.map((month, i) => {
          // if it's actually a year separator and not a month
          if (typeof month === 'number') {
            return (
              <div className="c-vertical-slider__year" key={month}>
                {month}
              </div>
            );
          }

          return (
            <div
              key={`${month.id}-${month.name}`}
              className={getClassNames(props, 'c-vertical-slider__slide', {
                'c-vertical-slider__slide--next-year': !!month.isNextYear,
                'is-active': i === activeIndex,
              })}
            >
              <Button
                fullHeight
                fixedWidth
                borderZero
                monthSlider
                blue
                id={month.id}
                index={i}
                onClick={(e) => handleEdit(e, i)}
                isActive={i === activeIndex}
                disabled={!month.available}
              >
                {month.name}
              </Button>
            </div>
          );
        })}
      </div>
    </div>
  );
};

MonthSlider.propTypes = {
  months: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string.isRequired,
    id: PropTypes.string.isRequired,
    available: PropTypes.bool.isRequired,
  }).isRequired).isRequired,
  filterConcerts: PropTypes.func.isRequired,
};

export default MonthSlider;
